import React from "react"

const SVG = ({
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 25 32'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d='M19.325 13.034h-2.174v-1.681c0-3.483-1.6-5.535-4.796-5.535s-4.796 2.048-4.796 5.535v1.681h-2.42c-0.655 0-1.188 0.78-1.188 1.434v9.345c0 0.655 0.533 1.354 1.147 1.56l1.434 0.453c0.614 0.206 1.681 0.368 2.335 0.368h6.97c0.655 0 1.721-0.166 2.335-0.368l1.434-0.453c0.614-0.206 1.147-0.901 1.147-1.56v-9.341c0.004-0.659-0.776-1.438-1.43-1.438zM9.935 10.905c0-1.721 0.941-2.622 2.42-2.622 1.434 0 2.42 0.901 2.42 2.622v2.174h-4.84v-2.174z'
    />
  </svg>
)

export default SVG